module.exports = __webpack_public_path__ + "static/media/icon-electronics.4a6329db.png";